var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.wShow)?_c('div',{staticClass:"wait-shadow"},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-outer"},[_c('div',{staticClass:"spinner-inner"})])}]

export { render, staticRenderFns }